import Entity from '../entity'

export default class City extends Entity<number>{
    name: string;
    country_id: number;
}


